import fetchApi from "../fetchApi";

export const AddCorporateCustomer = async (data) => {
  const options = {
    method: "POST",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(data),
    redirect: "follow",
  };

  return await fetchApi("corporate-customers", options);
};
